export default __webpack_public_path__ + "static/media/sd-banner-1.eae349b0.jpg";